import { styled } from 'styled-components';

import { getQueryByDevice } from '../../../styles/getQuery';

type SelectLinkProps = {
  'data-active': boolean;
};

const mediaQuery = getQueryByDevice(null, 'tabletS');

/**
 * Wrapper around the "input", which is actually a link
 * That way, we get deep linking support for toggling these
 */
export const Wrapper = styled.div<SelectLinkProps>`
  align-items: center;
  display: flex;
  height: 100%;
  outline: 0;
  padding: var(--spacing-tiny) var(--spacing-small);
  width: 100%;

  /* 
  When a Chip is inside:
  - Remove border
  - Add padding
  - Use inline-flex and width auto to fit content without full width stretch
  */
  /* stylelint-disable-next-line selector-class-pattern */
  &:has(.MuiChip-root) {
    background-color: var(--color-background-compose);
    border: none;
    display: inline-flex;
    width: auto;
  }

  @media ${mediaQuery} {
    border-left: none;
    border-radius: 0;
    border-right: none;
    border-top: none;
    justify-content: space-between;
    min-width: auto;
    padding: 0;
  }
`;
